import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=f328b936"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=f328b936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports